var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppliedStage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.664,
    height: 36.086,
    viewBox: "0 0 34.664 36.086",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-md-thumbs-up",
    "data-name": "Icon ionic-md-thumbs-up",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, -7.547, 4.644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2130",
    "data-name": "Path 2130",
    d: "M14.115,33.456h12.97a2.767,2.767,0,0,0,2.579-1.765l4.306-10.21a2.886,2.886,0,0,0,.2-1.056V17.515c0-1.591-1.282-3.363-2.85-3.363H22.327l1.357-6.146.045-.452A2.186,2.186,0,0,0,23.1,6.023L21.581,4.5l-9.5,9.6a2.9,2.9,0,0,0-.829,2.044V30.621A2.843,2.843,0,0,0,14.115,33.456Z",
    transform: "translate(0.57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2131",
    "data-name": "Path 2131",
    d: "M3.375,15.75H8.2V32.641H3.375Z",
    transform: "translate(0 0.815)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppliedStage);
export default __webpack_public_path__ + "static/media/applied-stage.1fc466f88e3a1b71a2be59c056d6428b.svg";
export { ForwardRef as ReactComponent };